import { useState, useEffect, useRef } from 'react';

interface Props {
  onAnalysisClick: () => void;
}

export default function Nav({ onAnalysisClick }: Props) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const hamburgerRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (
        !hamburgerRef.current?.contains(e.target as Node) &&
        !menuRef.current?.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  function closeMobile() { setOpen(false); }

  function handleAnalysis(e: React.MouseEvent) {
    e.preventDefault();
    closeMobile();
    onAnalysisClick();
  }

  return (
    <>
      <nav role="navigation" aria-label="Hlavná navigácia">
        <div className="nav-inner">
          <a href="#" className="nav-logo" aria-label="Boostio - domov">
            <div className="logo-mark" aria-hidden="true">
              <svg viewBox="0 0 16 16">
                <path d="M3 8.5L7 12.5L13 4" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            Boostio
          </a>
          <div className="nav-links" role="list">
            <a href="#sluzby"   role="listitem">Služby</a>
            <a href="#ceny"     role="listitem">Ceny</a>
            <a href="#projekty" role="listitem">Projekty</a>
          </div>
          <button className="nav-cta nav-desktop-cta" onClick={handleAnalysis}>
            Bezplatná analýza
          </button>
          <button
            ref={hamburgerRef}
            className="nav-hamburger"
            aria-label="Otvoriť menu"
            aria-expanded={open}
            aria-controls="mobile-menu"
            onClick={() => setOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <div
        ref={menuRef}
        id="mobile-menu"
        className={`nav-mobile${open ? ' open' : ''}`}
        role="dialog"
        aria-label="Mobilné menu"
      >
        <a href="#sluzby"   onClick={closeMobile}>Služby</a>
        <a href="#ceny"     onClick={closeMobile}>Ceny</a>
        <a href="#projekty" onClick={closeMobile}>Projekty</a>
        <button className="nav-cta" style={{ textAlign: 'center', marginTop: 8 }} onClick={handleAnalysis}>
          Bezplatná analýza
        </button>
      </div>
    </>
  );
}
